<template>
    <v-container id="wish-list-view">
        <bnft-wishlist :id="$route.params.id"></bnft-wishlist>
    </v-container>
</template>
<script>

import BnftWishlist from '../components/BnftWishlist.vue'

export default {
    name: "Wishlist",
    components: {
        BnftWishlist,
    },
};
</script>